import { FC } from 'react';

import SponsoredResultsPopover from '@core/shared/components/SponsoredResultsPopover';
import { VoyagerResult, VoyagerResultEnhancedSchoolData } from '@core/ts/results';
import cn from '@core/utils/classNames';

import Card from '../Card';
import styles from './ResultsList.module.css';

type Props = {
  header: string;
  subheader: string;
  results: VoyagerResult[];
  borrowedResults?: VoyagerResult[] | null;
  isExactMatch?: boolean;
  enhancedSchoolData?: VoyagerResultEnhancedSchoolData;
  showUgToGradResultsPageABTest?: boolean;
  showPsychBannerTest?: boolean;
};
const ResultsList: FC<Props> = ({
  enhancedSchoolData,
  header,
  subheader,
  results,
  isExactMatch = true,
  borrowedResults,
  showPsychBannerTest,
  showUgToGradResultsPageABTest,
}) => (
  <div className={showPsychBannerTest ? styles.matchListContainerNoTitle : styles.matchListContainer}>
    <div className={styles.matchListHeader}>
      {!showPsychBannerTest && <h2>{header}</h2>}

      <div className={styles.sponsored}>
        <SponsoredResultsPopover />
      </div>
    </div>

    {!showPsychBannerTest && <p className={styles.matchListSubheader}>{subheader}</p>}
    <div className={styles.sponsoredMobile}>
      <SponsoredResultsPopover />
    </div>

    <div className={cn(styles.resultsGrid, showUgToGradResultsPageABTest ? styles.threeColumns : styles.twoColums)}>
      {results?.map((result, index) => (
        <Card
          ctaLabel="Explore Program"
          key={result.program.id}
          result={result}
          enhancedSchoolData={enhancedSchoolData?.[result.school.sdbSchoolId]}
          eventingOverrides={{
            location: isExactMatch ? 'voyager-results-page' : 'voyager-related-results-page',
            customDimensions: [
              {
                key: 'isUserRequested',
                value: String(isExactMatch),
              },
            ],
          }}
          position={index + 1}
        />
      ))}
      {borrowedResults?.map((result, index) => (
        <Card
          ctaLabel="Explore Program"
          enhancedSchoolData={enhancedSchoolData?.[result.school.sdbSchoolId]}
          key={result.program.id}
          result={result}
          eventingOverrides={{
            location: 'voyager-results-page',
            customDimensions: [
              {
                key: 'isUserRequested',
                value: 'false',
              },
            ],
          }}
          position={index + 1}
        />
      ))}
    </div>
  </div>
);

ResultsList.defaultProps = {
  borrowedResults: null,
  isExactMatch: false,
};
export default ResultsList;
